export enum ContractualInformationConsent {
    RECEIVED_AND_REVIEWED = 'RECEIVED_AND_REVIEWED',
    RECEIVED_BUT_NOT_REVIEWED = 'RECEIVED_BUT_NOT_REVIEWED',
    NOT_RECEIVED = 'NOT_RECEIVED',
}
